import { render } from "./AnnouncementForm.vue?vue&type=template&id=48f9675d"
import script from "./AnnouncementForm.vue?vue&type=script&lang=js"
export * from "./AnnouncementForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__